import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=32d209a2&scoped=true&"
import script from "./Skeleton.vue?vue&type=script&lang=js&"
export * from "./Skeleton.vue?vue&type=script&lang=js&"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=32d209a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d209a2",
  null
  
)

export default component.exports